import React from 'react';

import GridContainer from '../../mui-components/Grid/GridContainer';
import ItemGrid from '../../mui-components/Grid/GridItem';
import RegularCard from '../../mui-components/Card/RegularCard';
import EmployeesTable from '../../containers/domain/employee/EmployeesTable';

const EmployeesListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de assessores"
        content={<EmployeesTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default EmployeesListingView;
